import React, { FC, useState } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionHeading,
  Text,
} from '@moonpig/launchpad-components'
import { ImportedHTML } from '@moonpig/web-shared-products'
import { DeliveryDetailsModule, ReviewsModule } from '../AccordionSections'
import { useProductDetailsAccordionTracking } from './useProductDetailsAccordionTracking'
import { useProductDetails } from './useProductDetails'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

export const ProductContentDetailsModule: FC<ProductModule> = props => {
  const { items, productId } = useProductDetails()
  const [selectedKeys, setSelectedKeys] = useState([items[0].key])
  const { onSelect } = useProductDetailsAccordionTracking(
    productId,
    selectedKeys,
    setSelectedKeys,
  )

  return (
    <ProductModuleSection {...props}>
      <Accordion
        onValueChange={onSelect}
        defaultValue={selectedKeys}
        type="multiple"
      >
        {items.map(item => {
          return (
            <AccordionContent
              key={item.key}
              heading={
                <AccordionHeading level="h2">
                  <Text
                    as="div"
                    typography={{
                      xs: 'typeMobileDisplay03',
                      md: 'typeDesktopDisplay05',
                    }}
                    textAlign="left"
                  >
                    {item.title}
                  </Text>
                </AccordionHeading>
              }
              value={item.key}
            >
              <ImportedHTML html={item.value} />
            </AccordionContent>
          )
        })}
        <DeliveryDetailsModule />
        <ReviewsModule />
      </Accordion>
    </ProductModuleSection>
  )
}
